import React from 'react';
import PropTypes from 'prop-types';
import { translate } from '../utils/translations';
import {
    tramaSmp0,
    tramaSmp1,
    tramaSmp2,
    tramaSmp3,
    llegendaSmp0,
    llegendaSmp1,
    llegendaSmp2,
    llegendaSmp3,
} from '../img';

const Legend = props => {
    const { language, trames } = props;

    return (
        <div
            className="legend"
            style={{
                display: '-webkit-flex',
                WebkitFlexDirection: 'column',
                WebkitFlexWrap: 'wrap',
            }}
        >
            <div>
                <img
                    src={trames ? tramaSmp0 : llegendaSmp0}
                    alt={translate(language, 'avisos_level_0')}
                />
                {translate(language, 'avisos_level_0')}
            </div>
            <div>
                <img
                    src={trames ? tramaSmp1 : llegendaSmp1}
                    alt={translate(language, 'avisos_level_1')}
                />
                {translate(language, 'avisos_level_1')}
            </div>
            <div>
                <img
                    src={trames ? tramaSmp2 : llegendaSmp2}
                    alt={translate(language, 'avisos_level_2')}
                />
                {translate(language, 'avisos_level_2')}
            </div>
            <div>
                <img
                    src={trames ? tramaSmp3 : llegendaSmp3}
                    alt={translate(language, 'avisos_level_3')}
                />
                {translate(language, 'avisos_level_3')}
            </div>
        </div>
    );
};

Legend.propTypes = {
    language: PropTypes.string,
};

export default Legend;



// WEBPACK FOOTER //
// ./src/partials/Legend.js